import { render, staticRenderFns } from "./Dlxkz.vue?vue&type=template&id=05f3be50&scoped=true&"
import script from "./Dlxkz.vue?vue&type=script&lang=js&"
export * from "./Dlxkz.vue?vue&type=script&lang=js&"
import style0 from "./Dlxkz.vue?vue&type=style&index=0&id=05f3be50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f3be50",
  null
  
)

export default component.exports